/**
 * Uses the `vio-flutter` on the user agent to determine if user is navigating in the mobile app.
 * @returns A boolean indicating if the user is navigating in the mobile app
 */
export const isFlutterMobileAppUserAgent = (): boolean => {
  // If no userAgent provided, try to get from window (client-side only)
  if (typeof window !== 'undefined' && window?.navigator?.userAgent) {
    return Boolean(window.navigator.userAgent.includes('vio-flutter'))
  }

  // Return false if we can't determine (server-side without userAgent parameter)
  return false
}
